export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Warm%20Italian%20boutique%20interior%20with%20curated%20fashion%20items%20hanging%20on%20wooden%20rack%20soft%20morning%20light%20through%20arched%20window%20cream%20textured%20walls%20terracotta%20floor%20tiles%20elegant%20retail%20space%20aesthetic%20minimalist%20luxury%20feel%20with%20clothing%20shoes%20and%20accessories%20arranged%20artistically&width=1800&height=1200&seq=hero-bg-v2-01&orientation=landscape')`,
        }}
      >
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/40 to-background-50/90"></div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-16">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 text-center lg:text-left pt-20 lg:pt-0">
            <span className="inline-block px-4 py-1.5 rounded-full border border-primary-200 bg-primary-50/80 text-primary-700 text-xs font-medium mb-6">
              ✦ Guida Aggiornata 2026
            </span>

            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-6 animate-fade-in-up">
              Itaobuy Spreadsheet{' '}
              <span className="text-primary-500 italic">Italia</span>
              <br />
              <span className="text-foreground-700 text-3xl md:text-4xl lg:text-5xl font-medium">
                La guida completa per trovare prodotti migliori
              </span>
            </h1>

            <p className="text-foreground-600 text-base md:text-lg leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8 animate-fade-in-up-delay-1">
              Scopri come utilizzare Itaobuy Spreadsheet, analizzare prodotti, confrontare informazioni e navigare in modo più sicuro. Guide dettagliate, recensioni e consigli pratici in italiano.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start animate-fade-in-up-delay-2">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="group w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all shadow-sm whitespace-nowrap cursor-pointer"
              >
                itaobuy sheet
                <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="group w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full border-2 border-foreground-300 text-foreground-800 text-base font-semibold hover:border-foreground-400 hover:bg-foreground-50/50 transition-all whitespace-nowrap cursor-pointer"
              >
                buy it now
                <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-6 mt-8 justify-center lg:justify-start text-xs text-foreground-500 animate-fade-in-up-delay-3">
              <span className="flex items-center gap-1.5">
                <i className="ri-check-line text-accent-500"></i> Guide aggiornate 2026
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-check-line text-accent-500"></i> Informazioni in italiano
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-check-line text-accent-500"></i> Consigli sulla sicurezza
              </span>
            </div>
          </div>

          <div className="flex-1 hidden lg:flex justify-center items-center">
            <div className="relative w-full max-w-lg aspect-[4/3] rounded-2xl overflow-hidden shadow-lg animate-float-slow">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20of%20premium%20fashion%20sneakers%20with%20terracotta%20vase%20and%20dried%20olive%20branch%20on%20cream%20linen%20fabric%20soft%20Mediterranean%20sunlight%20casting%20gentle%20shadows%20warm%20beige%20and%20sage%20tones%20European%20editorial%20photography%20elegant%20still%20life%20composition&width=800&height=600&seq=hero-side-v2-02&orientation=landscape"
                alt="Itaobuy Spreadsheet prodotti moda"
                title="Itaobuy Spreadsheet - Scopri i prodotti"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}